export default __webpack_public_path__ + "static/media/PlayNow.1d96b1cf.png";